type ModalData = {
    header?: string;
    body: string;
    showCloseButton?: boolean;
    showConfirmButton?: boolean;
    closeButtonLabel?: string;
    confirmButtonLabel?: string;
    closeButtonClass?: string;
    confirmButtonClass?: string;
};

export class ModalContent {
    header?: string;
    body: string;
    showCloseButton?: boolean;
    showConfirmButton?: boolean;
    closeButtonLabel?: string;
    confirmButtonLabel?: string;
    closeButtonClass?: string;
    confirmButtonClass?: string;

    constructor(modalData?: ModalData) {
        this.header = modalData?.header || '';
        this.body = modalData?.body || '';
        this.showCloseButton = modalData?.showCloseButton !== false;
        this.showConfirmButton = modalData?.showConfirmButton !== false;
        this.closeButtonLabel = modalData?.closeButtonLabel || 'Close';
        this.confirmButtonLabel = modalData?.confirmButtonLabel || 'Confirm';
        this.closeButtonClass = modalData?.closeButtonClass || '';
        this.confirmButtonClass = modalData?.confirmButtonClass || '';
    }
}
